import React, { memo, useContext, useEffect } from "react";
import { JunctionsNode } from "../../../masters/items/queries/queries";
import { nodeVar } from "../../../../../../utils/commonQueryTypes";
import { Junction } from "../../../masters/subsidary/junctions/queries/types";
import { useLazyQuery } from "@apollo/client";

import { AppContext } from "../../../../../../context/context";
import { PriorityEnum } from "../../../../../../utils/Enum.types";

const JunctionDetails = () => {


  const { state } = useContext(AppContext);

  const [getJunctionByNode, { data }] = useLazyQuery<
    { node: Junction },
    nodeVar
  >(JunctionsNode);

  useEffect(() => {
    if (state.junctionID) {
      getJunctionByNode({
        variables: {
          id: state.junctionID,
         
        }
      });
    }
  }, [getJunctionByNode, state.junctionID]);
  if (data) {
    const JunctionImage = require(`../../../../../../images/ItemIcons/${
      data.node.icon ? data.node.icon : "junction"
    }.svg`);
    return (
      <>
        <div
          className={`d-signal-complete-details--h--flex ${
            data.node.priority === PriorityEnum.CRITICAL
              ? "border-red"
              : data.node.priority === PriorityEnum.MEDIUM
              ? "border-yellow"
              : data.node.priority === PriorityEnum.LOW
              ? "border-green"
              : ""
          }

          `}
        >
          <img src={JunctionImage} alt="" />
          <div>
            <b className="d-signal-complete-details--h--item">
              {data.node.name} 
            </b>{" "}
            <span>
              {data.node.code},{data.node.alias}
            </span>
            <div className="d-signal-complete-details--h--span">
              <span>
                {data.node.vendorDetails.desc}, Arms: {data.node.arms}
              </span>
            </div>
          </div>
        </div>
      </>
    );
  } else return <b className="nodata">Asset not found</b>;
};

export default memo(JunctionDetails);
